import { TEventsState } from './types';

export function getListOfEvents(state: TEventsState) {
  return state.listOfEvents;
}

export function getEventsTable(state: TEventsState) {
  return state.eventsTable;
}

export function getMinistryEventsTable(state: TEventsState) {
  return state.ministryEventsTable;
}

export function getIndicatorCards(state: TEventsState) {
  return state.indicatorCards;
}
